import React, { useContext } from 'react';
import { withRouter } from '../WithRouter';
import PropTypes from 'prop-types';
import { ProfileContext } from '../../context/Profile.context';
import { Box, TaskNavigation } from '@otcmarketsgroup/otcm-ui-lib';
import { sections } from '../../constants/sections';
import { appStatuses } from '../../constants';
import { testIds } from '../../constants/testIds';

const ProfileNav = ({ params: { symbol, formSection }, navigate }) => {
  const [profileState] = useContext(ProfileContext);
  const profileData = profileState.profile;
  const verifiedSections = profileData.verifiedSections;
  const isReadOnly = profileState.profile.status?.id === appStatuses.NO_APPLICATION;

  const tasks = sections.map((section, i) => {
    let path = section.path;
    const isActive = path === formSection;
    const isComplete = verifiedSections[section.key];

    if (section.tabs) path = `${path}/${section.tabs[0]}`;

    return {
      id: path,
      title: section.name,
      number: i + 1,
      isActive,
      isComplete,
      isDisabled: isReadOnly && section.disableReadOnly
    };
  });

  return (
    <Box component='nav' data-testid={testIds.nav}>
      <TaskNavigation
        tasks={tasks}
        onTaskClick={(path) => navigate(`/manage/${symbol}/${path}`)}
      />
    </Box>
  );
};

ProfileNav.propTypes = {
  params: PropTypes.shape({
    symbol: PropTypes.string,
    formSection: PropTypes.string
  }),
  navigate: PropTypes.func
};

export default withRouter(ProfileNav);
